@use '../../../../styles/scss/vcom/mixins/breakpoints';
.vs-ct-3-up.vs-ct {

    &.vs-ect {
  
      .vs-ct-overlay {
        
        @include breakpoints.desktop-up {
          transform: translateY(calc(100% - 112px));
        }
  
        @include breakpoints.desktop-plus-up {
          transform: translateY(calc(100% - 120px));
        }
      }
    }
  
    &.vs-sct {
  
      .vs-link-cta {
        font-size: 24px;
  
        &::after {
          font-size: 14px;
          
          @include breakpoints.desktop-up {
            font-size: 20px;
          }
          
          @include breakpoints.desktop-plus-up {
            font-size: 24px;
          }
        }
  
        @include breakpoints.tablet-up {
          font-size: 16px;
        }
  
        @include breakpoints.desktop-plus-up {
          font-size: 28px;
        }
  
        &.vs-link-secondary {
          &::after {
            top: 0;
            
            @include breakpoints.tablet-up {
              top: 2px;
            }
  
            @include breakpoints.desktop-up {
              top: 4px;
            }
          }
        }
  
        &.vs-link-new-window,
        &.vs-link-outside,
        &.vs-link-modal {
          &::after {
            top: 0;
            
            @include breakpoints.desktop-up {
              top: 3px;
            }
          }
        }
      }
    
      .vs-ct-overlay {
  
        @include breakpoints.tablet-up {
          padding: 15px 15px 0 15px;
        }
  
        @include breakpoints.desktop-up {
          padding: 20px 20px 0 20px;
        }
  
        @include breakpoints.desktop-plus-up {
          padding: 40px 40px 0 40px;
        }
      }
    }
  }